<template>
  <div class="tab_content">
    <p class="tab_title">是否估值或评估</p>
    <div class="tab_form">
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="是否估值或评估">
          <el-radio-group v-model="form.isValuation">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">评估报告</el-radio>
            <el-radio :label="3">审计</el-radio>
            <el-radio :label="2">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.isValuation && form.isValuation !== 0">
          <el-form-item :label="'第三方' + labelWord + '机构名称'">
            <el-input v-model="form.thirdPartyAgency" placeholder="请输入" />
          </el-form-item>
          <el-form-item :label="'知识产权' + labelWord + '金额'">
            <el-select
              v-model="form.valuationReportAgencyAmountUnit"
              placeholder="单位"
              style="width: 150px; margin-right: 10px"
            >
              <el-option label="人民币(CNY)" value="人民币(CNY)" />
              <el-option label="美元(USD)" value="美元(USD)" />
              <el-option label="欧元(EUR)" value="欧元(EUR)" />
              <el-option label="英镑(GBP)" value="英镑(GBP)" />
              <el-option label="日元(JPY)" value="日元(JPY)" />
            </el-select>
            <el-input
              v-model="form.valuationAmount"
              placeholder="请输入"
              style="width: 200px"
              oninput="value=value.replace(/[^\d.]/g,'')"
            />
            <span style="margin-left: 8px">万元</span>
          </el-form-item>
          <el-form-item :label="labelWord + '基准日'">
            <el-date-picker
              v-model="form.valuationDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </el-form-item>
        </template>
        <div class="button flex-center">
          <el-button type="primary" @click="$emit('aChange', 'tab4')">上一步</el-button>
          <el-button type="primary" @click="doStaging">暂存</el-button>
          <el-button type="primary" @click="doSubmit">下一步</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "cfrom"],
  computed: {
    labelWord() {
      const map = { 1: "评估", 3: "审计", 2: "估值" };
      return map[this.form.isValuation] || "评估";
    },
  },
  data() {
    return {
      form: {
        isValuation: 0,
        thirdPartyAgency: "",
        valuationAmount: "",
        valuationReportAgencyAmountUnit: "人民币(CNY)",
        valuationDate: "",
      },
    };
  },
  methods: {
    doStaging() {
      const value = { ...this.form };
      if (this.id) value.id = this.id;
      this.$emit("aStagin", value);
    },
    doSubmit() {
      const value = { ...this.form };
      if (this.id) value.id = this.id;
      this.$emit("aChange", "tab6", value);
    },
  },
  watch: {
    cfrom() {
      if (!this.cfrom || !this.cfrom.id) return;
      this.form = {
        isValuation: this.cfrom.isValuation !== undefined ? this.cfrom.isValuation : 0,
        thirdPartyAgency: this.cfrom.thirdPartyAgency || "",
        valuationAmount: this.cfrom.valuationAmount || "",
        valuationReportAgencyAmountUnit: this.cfrom.valuationReportAgencyAmountUnit || "人民币(CNY)",
        valuationDate: this.cfrom.valuationDate || "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_content {
  margin: 0 30px;
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .tab_form {
    margin-top: 20px;
    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
  }
}
</style>
